import { memo } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils/cn";

interface LanguageSwitcherProps {
  variant?: "light" | "dark";
  className?: string;
}

const LANGS = ["PL", "EN"] as const;

const LanguageSwitcher = ({ variant = "dark", className }: LanguageSwitcherProps) => {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "EN" : "PL";

  const setLang = (lng: "PL" | "EN") => {
    void i18n.changeLanguage(lng.toLowerCase());
  };

  return (
    <div
      role="group"
      aria-label={t("nav.language")}
      className={cn(
        "inline-flex items-center gap-1 text-sm font-medium",
        className
      )}
    >
      {LANGS.map((lng, i) => {
        const active = current === lng;
        return (
          <span key={lng} className="flex items-center gap-1">
            <button
              type="button"
              onClick={() => setLang(lng)}
              aria-pressed={active}
              className={cn(
                "px-1.5 py-1 transition-colors",
                active
                  ? variant === "light"
                    ? "text-white font-semibold"
                    : "text-primary font-semibold"
                  : variant === "light"
                    ? "text-white/70 hover:text-white"
                    : "text-muted-foreground hover:text-primary"
              )}
            >
              {lng}
            </button>
            {i === 0 && (
              <span
                aria-hidden="true"
                className={cn(
                  variant === "light" ? "text-white/40" : "text-muted-foreground/50"
                )}
              >
                /
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
};

export default memo(LanguageSwitcher);
